
import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <Button
        variant="ghost"
        className="mb-4"
        onClick={() => navigate(-1)}
      >
        ← Back
      </Button>
      
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      
      <div className="space-y-6 text-left">
        <p className="text-sm text-gray-600">Effective Date: 2/16/25</p>
        <p className="text-sm text-gray-600">Last Updated: 2/16/25</p>
        <p className="text-sm text-gray-600">Version: 1.1</p>
        
        <section className="space-y-3">
          <h2 className="text-xl font-semibold">1. Acceptance of Terms</h2>
          <p>By accessing and using Alfie, you agree to these Terms of Service. If you do not agree, do not use our services. Alfie is a product developed by Moxi-Kaizen, a company operating out of California.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">2. Definitions</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>"Service" refers to Alfie and all related services</li>
            <li>"User" refers to any individual or entity using the Service</li>
            <li>"Content" refers to all information and materials available through the Service</li>
            <li>"Account" refers to a user's registered profile and associated data</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">3. Service Description</h2>
          <p>Alfie allows users to enter a prompt to schedule meetings with their contacts. The app accesses the user's calendar and contact list to find relevant participants and schedules meetings by sending invites. Alfie does not guarantee meeting accuracy and is dependent on the accuracy of the user's calendar and contacts.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">4. Service Level Agreement (SLA)</h2>
          <p>We strive to maintain 99.9% service uptime, excluding scheduled maintenance. However:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Scheduled maintenance will be announced at least 24 hours in advance</li>
            <li>Emergency maintenance may occur without notice</li>
            <li>We do not guarantee specific response times for support requests</li>
            <li>Service availability may be impacted by third-party dependencies</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">5. User Obligations</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of their account credentials</li>
            <li>Use the service in compliance with all applicable laws</li>
            <li>Not attempt to circumvent service limitations or security measures</li>
            <li>Not use the service for any unauthorized or illegal purposes</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">6. Account Terms</h2>
          <p>We reserve the right to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Suspend or terminate accounts for violations of these terms</li>
            <li>Modify or discontinue accounts features with notice</li>
            <li>Remove any content that violates these terms</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">7. Service Modifications</h2>
          <p>We reserve the right to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Modify or discontinue any service feature</li>
            <li>Change service specifications or requirements</li>
            <li>Update or change service pricing with notice</li>
            <li>Add new service limitations or restrictions</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">8. Payment Terms</h2>
          <p>While the service is currently free, we reserve the right to introduce fees in the future. If implemented:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Users will be notified of pricing changes 7 to 30 days in advance</li>
            <li>Payment will be required to maintain service access</li>
            <li>Refunds will be handled according to our refund policy</li>
            <li>Users may cancel service at any time</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">9. Intellectual Property</h2>
          <p>All rights, title, and interest in Alfie, including its software, branding, and content, are owned by Moxi-Kaizen. Users may not copy, modify, distribute, or exploit any part of Alfie without written consent.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">10. Third-Party Services</h2>
          <p>Alfie integrates with Google Calendar and Google Contacts. Users must comply with Google's policies. Moxi-Kaizen is not responsible for data inaccuracies, outages, or limitations imposed by Google.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">11. Disclaimer of Warranties</h2>
          <p>Alfie is provided "as is" and "as available" without warranties of any kind. Moxi-Kaizen does not guarantee uninterrupted or error-free performance.</p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
